import React from "react";

const SRC = {
  header: "/icons/icon-96.png",
  page: "/icons/icon-96.png",
  login: "/icons/icon-192.png",
};

const PX = { header: 36, page: 32, login: 112 };

export function OfficialLogo({ size = "header", decorative = false, className = "" }) {
  const px = PX[size] || PX.header;
  return (
    <span className={`og-logo og-logo--${size}${className ? ` ${className}` : ""}`} data-testid="official-logo">
      <img
        src={SRC[size] || SRC.header}
        alt={decorative ? "" : "Logo Orignal 2026"}
        width={px}
        height={px}
        decoding="async"
      />
    </span>
  );
}
